export default
{
  "and": [
    {
      "some": [
        {
          "var": "cars"
        },
        {
          "in": [
            "toyo",
            {
              "var": "model"
            }
          ]
        }
      ]
    }
  ]
};